<template>
  <b-container class="square-terminal-add-location">
    <b-row
      v-if="loading"
      class="mt-3"
    >
      <b-col>
        <loading-spinner>
          <div slot="title">
            Please wait while loading available device locations
          </div>
        </loading-spinner>
      </b-col>
    </b-row>

    <b-row
      v-if="!loading"
      class="mt-3"
    >
      <b-col>
        <b-input-group prepend="Name">
          <b-input
            v-model="device.name"
            :disabled="processing"
          />
        </b-input-group>
        <b-input-group prepend="Location">
          <b-select
            v-model="device.locationid"
            :options="deviceLocations"
            :disabled="processing"
          />
        </b-input-group>
        <b-input-group prepend="Registration Code">
          <b-input
            v-model="device.code"
            :disabled="processing"
          />
        </b-input-group>
        <div class="buttons">
          <b-button
            :disabled="processing || !deviceReady"
            variant="primary"
            @click="registreNewDevice"
          >
            <slot>
              Register Device
            </slot>
            <b-spinner
              v-if="processing"
              small
            />
          </b-button>
          <b-button
            variant="primary"
            :disabled="processing"
            @click="cancelAddDevice"
          >
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'square-terminal-add-device',
  data: function() {
    return {
      loading: false,
      processing: false,
      device: {
        name: '',
        locationid: '',
        code: ''
      }
    }
  },
  computed: {
    locations: function() {
      return this.$store.state.square.terminalLocations
    },
    deviceLocations: function() {
      return this.locations.map(loc => {
        return { value: loc.id, text: loc.display_name }
      })
    },
    deviceReady: function() {
      return this.device.name.trim().length &&
        this.device.locationid.trim().length &&
        this.device.code.trim().length
    },
    devices: function() {
      return this.$store.state.square.terminalDevices
    },
    newDeviceDetails: function() {
      return {
        locationid: this.device.locationid,
        label: this.device.name.trim(),
        code: this.device.code.trim()
      }
    }
  },
  mounted: function() {
    this.loading = true
    return Promise.all([
      this.$store.dispatch('square/loadTerminalDevices'),
      this.$store.dispatch('square/loadTerminalLocations')
    ])
      .then(_ => {
        this.loading = false
      })
  },
  methods: {
    cancelAddDevice: function() {
      this.$emit('cancel')
    },
    registreNewDevice: function() {
      if (!this.allowSimulatedReader && this.newDeviceDetails.code === 'simulated-wpe') {
        this.$emit('error', { device: this.newDeviceDetails, error: new Error('You are not allowed to add the simulated reader on this installation.') })
      }
      // Check that the terminal device name is unique
      this.processing = true
      if (this.devices.find(device => device.label.trim().toLowerCase() === this.device.name.trim().toLowerCase())) {
        this.$emit('error', { device: this.device, error: new Error(`Device Name ${this.device.name} already exists.`) })
      }
      else {
        this.$store.dispatch('square/addTerminalDevice', this.newDeviceDetails)
          .then(_ => this.$store.dispatch('square/loadTerminalDevices', { force: true }))
          .then(_ => {
            this.$emit('success', this.newDeviceDetails)
          })
          .catch(err => {
            this.$emit('error', { device: this.newDeviceDetails, error: err })
          })
          .finally(_ => {
            this.processing = false
          })
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .square-terminal-add-location {
    .input-group {
      margin: 10px 0px;
    }
    .buttons {
      display: flex;
      flex-direction: row;
      gap: 2.2rem;
    }
  }
</style>
